module.exports = __webpack_public_path__ + "static/media/submit.6ec1b858.jpg";